import { reducer } from 'src/redux/profile/profile.slice'
import { GetProfileAction } from 'src/redux/profile/profile.action'

export default { reducer, GetProfileAction }
